import { makeRequest } from '../base/axios.ts'

export default {
  create: function (spammableId, spammableType, spamOrHam, training = false) {
    const data = {
      spammable_id: spammableId,
      spammable_type: spammableType,
      spam_or_ham: spamOrHam,
      training,
    }
    return makeRequest({
      url: '/api/v1/spam_hams',
      method: 'post',
      data,
      requestId: `post-spam-ham-${spammableType}-${spammableId}`,
    })
  },
}
